<template>
    <div class="container">
        <div class="paramForm">
            <el-form :model="params" label-width="90px">
                <el-row>
                    <el-form-item label="关联产品">
                        <el-select v-model="params.pid" clearable>
                            <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="会员地址">
                        <el-input v-model="params.memberAddress" clearable class="param-address"></el-input>
                    </el-form-item>
                    <el-form-item label="订单状态">
                        <el-select v-model="params.status" clearable>
                            <el-option v-for="item in statusOptions" :key="item.code" :label="item.name" :value="item.code"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div class="paramFormButton">
                <el-button type="primary" icon="el-icon-search" @click="handleCurrentChange(1)">搜索</el-button>
            </div>
        </div>
        <div class="tableTool">
            <el-button type="primary" icon="el-icon-printer" @click="exportExcel">导出</el-button>
        </div>
        <el-table border ref="tableRef" id="out-table" :data="tableData" highlight-current-row class="table-show-current">
            <el-table-column prop="id" align="center" label="订单ID" width="60"></el-table-column>
            <el-table-column prop="category" label="类型" align="center" width="100">
                <template slot-scope="scope">{{scope.row.category == 1?"借贷池订单":"杠杆池订单"}}</template>
            </el-table-column>
            <el-table-column prop="name" label="名称" align="center" show-overflow-tooltip>
                <template slot-scope="scope" v-if="scope.row.category == 2">{{scope.row.name}}</template>
            </el-table-column>
            <el-table-column label="周期" align="center" width="60">
                <template slot-scope="scope" v-if="scope.row.category == 2">
                    <span>{{scope.row.cycle}} 天</span>
                </template>
            </el-table-column>
            <el-table-column label="日利率" align="center" width="60">
                <template slot-scope="scope">{{showApy(scope.row.dayRate)}}</template>
            </el-table-column>
            <el-table-column align="center" label="会员地址" width="150" class-name="address">
                <template slot-scope="scope" v-if="scope.row.memberAddress">
                    <span v-clipboard:copy="scope.row.memberAddress" v-clipboard:success="onCopy">
                        {{scope.row.memberAddress.slice(0,5) + "..." + scope.row.memberAddress.slice(-5)}}<i class="el-icon-document-copy"/>
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="总金额" align="center">
                <template slot-scope="scope">{{ scope.row.amount }}</template>
            </el-table-column>
            <el-table-column label="起息日" align="center" width="100">
                <template slot-scope="scope">{{ formatDate2(new Date(scope.row.profitStartAt)) }}</template>
            </el-table-column>
            <el-table-column label="结束日" align="center" width="100">
                <template slot-scope="scope">{{ formatDate2(new Date(scope.row.profitEndAt)) }}</template>
            </el-table-column>
            <el-table-column label="累计收益" align="center" prop="orderProfit"></el-table-column>
            <el-table-column label="订单状态" align="center">
                <template slot-scope="scope"><span :class="'status_'+scope.row.status">{{ statusMap[scope.row.status] }}</span></template>
            </el-table-column>
            <el-table-column align="center" label="质押链上Hash" width="150" class-name="address">
                <template slot-scope="scope">
                    <a v-if="scope.row.buyTxHash" target="_blank" :href="getChainScan()+'/tx/'+scope.row.buyTxHash">{{showHash(scope.row.buyTxHash)}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="updatedAt" label="更新时间" align="center" width="140"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total,sizes, prev, pager, next"
                :current-page="pageInfo.pageNum"
                :page-size="pageInfo.pageSize"
                :page-sizes="[10, 20, 50, 100, 200]"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
import { aldServiceApi  } from '@/api/api-ald';
import { exportData1,exportData2 } from '@/assets/js/exportExcel';
export default {
    data() {
        return {
            params: {category:2},
            total:0,
            pageInfo: {
                pageNum: 1,
                pageSize: 10
            },
            tableData:[],
            productList:[],
        };
    },
    created() {
        this.statusOptions = this.findDict("ALD_ORDER2_STATUS");
        this.statusMap = this.listToMap(this.statusOptions,"code","name");
        aldServiceApi.findProductAllList().then(res => {
            this.productList = res;
        });
        this.handleSearch();
    },
    methods: {
        onCopy() {
            this.$message.success({message: "复制成功",duration: 600})
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            this.handleSearch();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNum = val;
            this.handleSearch();
        },
        handleSearch() {
            aldServiceApi.findOrderPageList(this.params,this.pageInfo).then(res => {
                this.tableData = res.records;
                this.total = res.total || 0;
            });
        },
        exportExcel() {
            if(!this.tableData || this.tableData.length==0){
                this.$message.warning({message: "没有可导出的数据",duration: 600})
                return;
            }
            let header = ['订单ID','产品名称','类型','会员地址',
            '购买时间','购买数量','购买单价','总金额','当前价值','起息日','计息结束日',
            '实际每日年化','实际阶梯年化','累计收益','最近领取时间',
            "订单状态","续订状态",
            '申请赎回时间','实际赎回价值','赎回手续费','完成赎回时间',"更新时间"];

            let columns = ['id', 'name','type','memberAddress',
            'buyAt', 'numKeep', 'priceOld', 'valuePay',"curTotalValue","profitStartAt",'profitEndAt',
            "apyDay","apyLadder","sumProfitSelf",'takeRemainAt','status','renewalFlag',
            "redeemApplyAt","redeemValue","redeemFee",'redeemFinishAt','updatedAt',
        ];
            let data = this.tableData.map(r => columns.map(c => {
                let val = r[c];
                if(c == 'curTotalValue'){
                    return r["priceCur"] * r["numKeep"];
                }
                return val; 
            }));
            exportData2(header,data,"订单数据");
        }
    }
};
</script>
<style lang='less' scope>
span.status_CANCEL{
    color:red;
}
span.status_CONFIRM{
    color:green;
}
span.status_PENDING{
    color:gray;
}


</style>

<style lang='less' scope>
span.status_NORMAL{
    color:#ffffff;
    background-color: green;
    padding: 2px 10px;
    border-radius: 20px;
}
span.status_REDEEM_PENDING{
    color:#000000;
    background-color: yellow;
    padding: 2px 10px;
    border-radius: 20px;
}
span.status_REDEEM_FINISH{
    color:#aaaaaa;
    background-color: #dddddd;
    padding: 2px 10px;
    border-radius: 20px;
}
</style>